import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CompanyService } from 'app/services/company.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit {
  @ViewChild('videoElement') videoElement: ElementRef<HTMLVideoElement>;

  aboutUsContent: string;
  isLoading: boolean = false;
  isVideoPaused: boolean = true;
  aboutUsVideo: string;

  constructor(private companyService: CompanyService) {}

  ngOnInit() {
    this.getAboutUs();
  }

  getAboutUs() {
    this.isLoading = true;
    this.companyService.getCompanyAbout().subscribe(
      (data: any) => {
        this.aboutUsContent = data?.aboutUs;
        this.aboutUsVideo = data?.aboutUsVideo || 'assets/videos/about-us.mp4'; // Replace with an actual default URL if needed
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching about us content', error);
        this.isLoading = false;
      }
    );
  }

  toggleVideoPlay(videoElement: HTMLVideoElement) {
    // If video is paused, play it and update state
    if (videoElement.paused) {
      videoElement.play();
      this.isVideoPaused = false;
    }
    // If video is playing, pause it and update state
    else {
      videoElement.pause();
      this.isVideoPaused = true;
    }
  }

  // Additional method to handle video state when video ends
  onVideoEnded() {
    this.isVideoPaused = true;
    // Optional: reset video to start
    if (this.videoElement) {
      this.videoElement.nativeElement.currentTime = 0;
    }
  }

  onVideoLoadedMetadata() {
    // You can perform any initial video setup here
    this.isVideoPaused = true;
  }
}
